module.exports = __webpack_public_path__ + "static/media/lightBackground.cbae7b0b.png";